import {
  Calendar,
  CheckCircle,
  CircleConcentricFilled,
  Clipboard,
  Coin,
  Jerrycan,
  LocationPin,
  NumberTen,
  Odometer,
  Paperclip,
  Paragraph,
  PencilSquiggle,
  SquareGrid,
  Text,
  Toggle,
  VehicleTruck,
} from 'phx-core';
import { IMobileComponentItem } from '../../../misc/mobile-view-builder/mobile-component-item.component';

export enum FORM_ELEMENT_KEYS {
  NUMBER = 'integer',
  TEXT = 'string',
  PARAGRAPH = 'paragraph',
  DATE_TIME = 'datetime',
  DATE = 'date',
  COUNTRY_STATE_DROPDOWN = 'country_state_dropdown',
  SINGLE_SELECT = 'single_dropdown',
  MULTI_SELECT = 'multiple_dropdown',
  TOGGLE = 'boolean',
  SIGNATURE = 'signature',
  LOCATION = 'location',
  CURRENCY = 'currency',
  VOLUME = 'volume',
  ODOMETER = 'odometer',
  VEHICLE = 'vehicle_token',
  DRIVER = 'driver',
  EXPIRATION_DATE = 'expiration_date',
  VEHICLE_DOC_MEMBERS = 'vehicle_doc_members',
  PAGE = 'page',
  DESCRIPTION = 'description',
  ATTACHMENTS = 'attachment',
  FLOAT = 'float',
}

export enum FORM_INPUT_TYPES {
  SINGLE_INPUT = 'single-input',
  MULTI_OPTION_SINGLE_SELECT = 'multi-option-single-select',
  MULTI_OPTION_MULTI_SELECT = 'multi-option-multi-select',
  DATE_TIME_INPUT = 'date-time-input',
  DATE_INPUT = 'date-input',
  TOGGLE_INPUT = 'toggle-input',
  TEXT_PARAGRAPH = 'text-paragraph',
  MULTI_SWITCH_CONTROL = 'multi-switch-control',
  URL_INPUT = 'url-input',
  DROPDOWN_INPUT = 'dropdown-builder',
  COUNTRY_STATE_DROPDOWN = 'country-state-dropdown',
  EXPIRATION_DATE_INPUT = 'expiration-date-input',
  PAGE = 'page',
}

export type FORM_ELEMENT_TYPE =
  FORM_ELEMENT_KEYS.NUMBER |
  FORM_ELEMENT_KEYS.TEXT |
  FORM_ELEMENT_KEYS.PARAGRAPH |
  FORM_ELEMENT_KEYS.DATE_TIME |
  FORM_ELEMENT_KEYS.DATE |
  FORM_ELEMENT_KEYS.COUNTRY_STATE_DROPDOWN |
  FORM_ELEMENT_KEYS.SINGLE_SELECT |
  FORM_ELEMENT_KEYS.MULTI_SELECT |
  FORM_ELEMENT_KEYS.TOGGLE |
  FORM_ELEMENT_KEYS.SIGNATURE |
  FORM_ELEMENT_KEYS.LOCATION |
  FORM_ELEMENT_KEYS.CURRENCY |
  FORM_ELEMENT_KEYS.VOLUME |
  FORM_ELEMENT_KEYS.ODOMETER |
  FORM_ELEMENT_KEYS.VEHICLE |
  FORM_ELEMENT_KEYS.EXPIRATION_DATE |
  FORM_ELEMENT_KEYS.DRIVER |
  FORM_ELEMENT_KEYS.VEHICLE_DOC_MEMBERS |
  FORM_ELEMENT_KEYS.ATTACHMENTS |
  FORM_ELEMENT_KEYS.DESCRIPTION;

export interface ISingleInput {
  label: string;
  text: string;
  isRequired: string;
  extra?: unknown;
}

export const FORM_ELEMENT_LIST: IMobileComponentItem[] = [
  {
    key: FORM_ELEMENT_KEYS.NUMBER,
    moreSpecificType: 'float',
    title: $localize`Numbers`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.TEXT,
    title: $localize`Text`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.PARAGRAPH,
    title: $localize`Paragraph`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.DATE_TIME,
    title: $localize`Date & Time`,
    editorType: FORM_INPUT_TYPES.DATE_TIME_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.DATE,
    title: $localize`Date`,
    editorType: FORM_INPUT_TYPES.DATE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.COUNTRY_STATE_DROPDOWN,
    title: $localize`Country/State Dropdown`,
    editorType: FORM_INPUT_TYPES.COUNTRY_STATE_DROPDOWN,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.SINGLE_SELECT,
    title: $localize`Single Select`,
    editorType: FORM_INPUT_TYPES.MULTI_OPTION_SINGLE_SELECT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.MULTI_SELECT,
    title: $localize`Multi Select`,
    editorType: FORM_INPUT_TYPES.MULTI_OPTION_MULTI_SELECT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.TOGGLE,
    title: $localize`Toggle`,
    editorType: FORM_INPUT_TYPES.TOGGLE_INPUT,
    data: {},
    hideFooter: true,
  },
  {
    key: FORM_ELEMENT_KEYS.SIGNATURE,
    title: $localize`Signature`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.LOCATION,
    title: $localize`Location`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.CURRENCY,
    title: $localize`Currency`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.VOLUME,
    title: $localize`Volume`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.ODOMETER,
    title: $localize`Odometer`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.VEHICLE,
    title: $localize`Vehicle`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.DRIVER,
    title: $localize`Driver`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.EXPIRATION_DATE,
    title: $localize`Expiration date`,
    editorType: FORM_INPUT_TYPES.EXPIRATION_DATE_INPUT,
    data: {},
  },
  {
    key: FORM_ELEMENT_KEYS.VEHICLE_DOC_MEMBERS,
    title: $localize`Vehicle(s)`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
  },
];

export const CONDITIONAL_LOGIC_ENABLED_FORM_ELEMENT_LIST: IMobileComponentItem[] = [
  {
    key: FORM_ELEMENT_KEYS.DESCRIPTION,
    title: $localize`Description`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Clipboard,
    hideFooter: true,
    showLabel: false,
  },
  {
    key: FORM_ELEMENT_KEYS.NUMBER,
    moreSpecificType: 'float',
    title: $localize`Numbers`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: NumberTen,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.TEXT,
    title: $localize`Text`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Text,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.PARAGRAPH,
    title: $localize`Paragraph`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Paragraph,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.DATE_TIME,
    title: $localize`Date & time`,
    editorType: FORM_INPUT_TYPES.DATE_TIME_INPUT,
    data: {},
    icon: Calendar,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.SINGLE_SELECT,
    title: $localize`Single select`,
    editorType: FORM_INPUT_TYPES.MULTI_OPTION_SINGLE_SELECT,
    data: {},
    icon: CircleConcentricFilled,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.MULTI_SELECT,
    title: $localize`Multi select`,
    editorType: FORM_INPUT_TYPES.MULTI_OPTION_MULTI_SELECT,
    data: {},
    icon: CheckCircle,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.TOGGLE,
    title: $localize`Toggle`,
    editorType: FORM_INPUT_TYPES.TOGGLE_INPUT,
    data: {},
    icon: Toggle,
    hideFooter: true,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.SIGNATURE,
    title: $localize`Signature`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: PencilSquiggle,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.LOCATION,
    title: $localize`Location`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: LocationPin,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.CURRENCY,
    title: $localize`Currency`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Coin,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.VOLUME,
    title: $localize`Volume`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Jerrycan,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.ODOMETER,
    title: $localize`Odometer`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Odometer,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.VEHICLE,
    title: $localize`Vehicle`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: VehicleTruck,
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.DRIVER,
    title: $localize`Driver`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.EXPIRATION_DATE,
    title: $localize`Expiration date`,
    editorType: FORM_INPUT_TYPES.EXPIRATION_DATE_INPUT,
    data: {},
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.VEHICLE_DOC_MEMBERS,
    title: $localize`Vehicle(s)`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    showLabel: true,
  },
  {
    key: FORM_ELEMENT_KEYS.ATTACHMENTS,
    title: $localize`Attachments`,
    editorType: FORM_INPUT_TYPES.SINGLE_INPUT,
    data: {},
    icon: Paperclip,
    showLabel: false,
    maxComponents: 3,
    componentsInTemplate: 0,
  },
];

export const PAGE_ELEMENT: IMobileComponentItem = {
  key: FORM_ELEMENT_KEYS.PAGE,
  title: $localize`Page`,
  editorType: FORM_INPUT_TYPES.PAGE,
  data: {},
  icon: SquareGrid,
};

export const SUBMIT_NAVIGATION_KEY = 'submit';